// @flow
import * as React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton, ListItemIcon,
  ListItemText,
  ListSubheader
} from '@mui/material';
import { ModalCloseButton } from '@coverright/ui/shared';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { useSearchNavigation } from './hooks/use-search-navigation';
import { useState } from 'react';
import { SearchInput } from '@coverright/ui/inputs';

type Props = {
  open: boolean;
  onClose: () => void;
};
export const SearchAnythingModal = ({open, onClose}: Props) => {
  const [term, setTerm] = useState('');
  const [selected, setSelected] = useState(0);
  const navigation = useSearchNavigation()

  const onClick = (callback: () => void) => {
    setTerm('');
    onClose();
    callback();
  }

  const results = navigation.filter(item => item.title.toLowerCase().includes(term.toLowerCase()));

  const handleKeys = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowDown') {
      selected < results.length - 1 && setSelected(selected + 1);
    }
    if (event.key === 'ArrowUp') {
      selected > 0 && setSelected(selected - 1);
    }
    if (event.key === 'Enter') {
      onClick(results[selected].onClick)
    }
  }

  return (
    <Dialog fullWidth maxWidth={'sm'}
            onKeyDown={handleKeys}
            open={open}
            onClose={onClose}>
      <DialogTitle variant={'h3'}>
        Search anything
        <ModalCloseButton onClick={onClose} sx={{position: 'absolute', top: 4, right: 8}} />
      </DialogTitle>

      <Box sx={{px: 2, pb: 1}}>
        <SearchInput value={term}
                     onKeyDown={handleKeys}
                     onChange={v => {
                       setTerm(v);
                       setSelected(0);
                     }}
                     autoFocus InputProps={{
          startAdornment: <MagnifyingGlass size={24} />
        }} />
      </Box>
      <DialogContent sx={{pt: 0}}>
        <List>
          <ListSubheader>
            Navigation
          </ListSubheader>
          {results.map((menuItem, i) => (
            <ListItemButton dense
                            selected={i === selected}
                            onClick={() => onClick(menuItem.onClick)}
                            key={i} sx={{alignItems: 'flex-start'}}>
              <ListItemIcon sx={{minWidth: 32, mt: 1}}>
                {menuItem.icon}
              </ListItemIcon>
              <ListItemText  primary={menuItem.title} secondary={menuItem.subtitle} />
            </ListItemButton>
          ))}
        </List>
    </DialogContent>
    </Dialog>
  );
};
